import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '@/shared/api';
import config from '@/config';
import Tag from '@/shared/components/Tag';
import FormGroupPart from './partials/FormGroupPart';
import messages from './registrationMessages';

// Read-only display of the relation's tags that are marked "show on registration"
// (Tag.ShowOnRegistration), used on the registration create/edit screens. Styled
// the same (smaller) way as the tags on the relation fiche, but not editable here.
class RelationTagsOnRegistration extends Component {
  static propTypes = {
    relationId: PropTypes.string,
  };

  static defaultProps = {
    relationId: undefined,
  };

  state = {
    tags: null,
    relationId: undefined,
  };

  componentDidMount() {
    this.loadTags();
  }

  componentDidUpdate(prevProps) {
    const { relationId } = this.props;
    if (relationId !== prevProps.relationId) {
      this.loadTags();
    }
  }

  loadTags = () => {
    const { relationId } = this.props;

    if (!relationId) {
      this.setState({ tags: null, relationId });
      return;
    }

    api.base
      .get(`${config.appUrls.api}/api/relationtag/ForRegistration/${relationId}`)
      .then(({ data }) => {
        // Ignore stale responses when the relation changed again in the meantime
        if (this.props.relationId !== relationId) return;
        this.setState({ tags: data, relationId });
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('RelationTagsOnRegistration: failed to load tags for relation', relationId, error);
      });
  };

  render() {
    const { relationId } = this.props;
    const { tags, relationId: loadedRelationId } = this.state;

    if (!relationId || loadedRelationId !== relationId || !tags || tags.length === 0) return null;

    return (
      <div className="form-group registration-relation-tags">
        <FormGroupPart label={messages.Labels} inputCols="col-sm-10">
          {tags.map(tag => (
            <Tag key={tag.id} item={{ value: tag, name: tag.name }} color={tag.color} readOnly />
          ))}
        </FormGroupPart>
      </div>
    );
  }
}

export default RelationTagsOnRegistration;
